<template>
    <div>
        <div id="pdf-content">
        <h1>Hello PDF</h1>
        <p>This is a sample PDF content without any images.</p>
        </div>
        <!-- Menggunakan v-if untuk menampilkan tombol setelah 1 detik -->
        <button v-if="isVisibleButton" @click="downloadPDF">Download PDF</button>
    </div>

        <!-- <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col cols="12" class="text-center mb-5">
                        <img :src="`${publicPath}img/gep/logo-rcp.png`" class="my-3">
                        <h3>Proof of Personal Acocunt Details</h3>
                        <div class="text-grey">Generated on: 01/08/2024</div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mb-5">
                        <div class="fw-700 mb-5">To whom it may concern,</div>
                        <div class="fw-700">Personal account of RCPAY Limited</div>
                        <div>This letter confirms the below account details allow RCPAY Limited to receive payments into his/ her C Account:</div>
                    </b-col>
                    <b-col cols="12">
                        <table class="w-100 mb-3">
                            <tr>
                                <td colspan="2" class="fw-700 pb-4">GEP account details</td>
                            </tr>
                            <tr>
                                <td>Account Name</td>
                                <td class="fw-700 text-right pb-3">RCPAY Limited</td>
                            </tr>
                            <tr>
                                <td>Account Number</td>
                                <td class="fw-700 text-right pb-3">7931801000007317</td>
                            </tr>
                            <tr>
                                <td>Bank Name</td>
                                <td class="fw-700 text-right pb-3"> DBS BANK(HONG KONG) LIMITED</td>
                            </tr>
                            <tr>
                                <td>Bank SWIFT/BIC</td>
                                <td class="fw-700 text-right pb-3">DHBKHKHH</td>
                            </tr>
                            <tr>
                                <td>Bank Country</td>
                                <td class="fw-700 text-right pb-3">Hong Kong</td>
                            </tr>
                            <tr>
                                <td>Bank Address</td>
                                <td class="fw-700 text-right pb-3">G/F, The Center,99 Queen's Road Central, Central, Hong Kong</td>
                            </tr>
                        </table>
                        <button @click="generatePDF" class="btn btn-primary">Download PDF</button>
                    </b-col>
                </b-row>
            </div>
        </b-container> -->
</template>
<script>
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export default {
  data() {
    return {
      isVisibleButton: false, // Properti untuk mengatur visibilitas tombol
    };
  },
  mounted() {
    // Mengatur visibilitas tombol setelah 1 detik saat komponen dimuat
    setTimeout(() => {
      this.isVisibleButton = true;
    }, 1000); // Tunggu 1 detik
  },
  methods: {
    downloadPDF() {
      const element = document.getElementById("pdf-content");

      if (!element) {
        console.error("Element with ID 'pdf-content' not found");
        return;
      }

      html2canvas(element, { scale: 2, useCORS: true })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF();
          pdf.addImage(imgData, "PNG", 10, 10, 180, 0); // Tambahkan gambar ke PDF
          pdf.save("download.pdf"); // Simpan PDF
        })
        .catch((error) => {
          console.error("Error rendering PDF:", error);
        });
    },
  },
};
</script>

<style scoped>
#pdf-content {
  width: 800px; /* Tetapkan lebar tetap */
  padding: 20px; /* Tambahkan padding */
  border: 1px solid #000; /* Border untuk melihat area */
  background-color: #fff; /* Latar belakang putih */
}
</style>